'use strict';
import axios from "axios";
import Utility from "@/Common/Utility";

//let baseUrl = "https://localhost:44374";

let UploadManager = {
    MaxRunningTaskCount: 3, //最大同時可執行的 Upload Task 數量
    Tasks: new Array(),
    Status: "Ready",//Ready , Running , Suspended


    //Injection Event Start
    TaskProgressChange: null,
    TaskSuccess: null,
    TaskFail: null,
    //Injection Event End

    isExecuteUploadTasksRunning: false,
    lastTriggerAllTaskCompleteTime: new Date(),

    OnTaskProgressChange: function (taskId, progress) {
        if (this.TaskProgressChange != null) {
            this.TaskProgressChange(taskId, progress);
        }
    },

    OnTaskSuccess: function (taskId, responseText) {

        if (this.TaskSuccess != null) {
            this.TaskSuccess(taskId, responseText);
        }
    },

    OnTaskFail: function (taskId, responseText) {
        if (this.TaskFail != null) {
            this.TaskFail(taskId, responseText);
        }
    },

    OnTaskFileLoad: function (taskId, tempFileName) {
        if (this.TaskFileLoad != null) {
            this.TaskFileLoad(taskId, tempFileName);
        }
    },

    CreateTask: function (file, uploadPageUrl, targetFolderPath) {
        let uploadTask;

        uploadTask = new UploadTask(file, uploadPageUrl);

        //uploadTask.StateChange = this.OnTaskStateChange;
        uploadTask.ProgressChange = this.OnTaskProgressChange.bind(this);
        uploadTask.Success = this.OnTaskSuccess.bind(this);
        uploadTask.Fail = this.OnTaskFail.bind(this);
        uploadTask.FileLoad = this.OnTaskFileLoad.bind(this);

        if (targetFolderPath != null) {
            uploadTask.TargetFolderPath = targetFolderPath;
        }

        this.Tasks.push(uploadTask);

        return uploadTask;
    },

    StartAllTasks: function () {
        let i;

        if (typeof (maxRunningTaskCount) != "undefined") {
            this.MaxRunningTaskCount = maxRunningTaskCount;
        }

        for (i = 0; i < this.Tasks.length; i++) {
            this.Tasks[i].Start();
        }

        this.Status = "Running";
    },


    StopAllTasks: function () {
        var i;

        for (i = 0; i < this.Tasks.length; i++) {
            this.Tasks[i].Stop();
        }

        this.Status = "Ready";
    }
    ,

    Suspend: function () {
        this.Status = "Suspended";
    },

    Resume: function () {
        this.Status = "Ready";
    },

    StopTask: function (taskId) {
        var i;

        for (i = 0; i < this.Tasks.length; i++) {
            if (this.Tasks[i].Id == taskId) {
                this.Tasks[i].Stop();
                break;
            }
        }
    },

    RemoveTask: function (taskId) {
        var i;

        for (i = 0; i < this.Tasks.length; i++) {
            this.Tasks[i].Stop();
            this.Tasks[i].Dispose();
            this.Tasks[i].removeAt(i);
            break;
        }
    },

    RemoveAllTasks: function () {
        var i;

        for (i = 0; i < this.Tasks.length; i++) {
            this.Tasks[i].Stop();
            this.Tasks[i].Dispose();
            this.Tasks[i] = null;
        }

        this.Tasks.length = 0
    }
    ,

    GetTask: function (taskId) {
        var task = null;
        var i;

        for (i = 0; i < this.Tasks.length; i++) {
            if (this.Tasks[i].Id == taskId) {
                task = this.Tasks[i];
                break;
            }
        }

        return task;
    },

    GetRunningTaskCount: function () {
        var runningTaskCount = 0;
        var i;

        for (i = 0; i < this.Tasks.length; i++) {
            if (this.Tasks[i].Status == "Running") {
                runningTaskCount++;
            }
        }

        return runningTaskCount;
    }
    ,


    ExecuteUploadTasks() {
        if (this.isExecuteUploadTasksRunning) {
            return;
        }
        else {
            this.ExecuteUploadTasksImpl();
        }
    },

    ExecuteUploadTasksImpl() {
        let runningTaskCount = 0;
        let triggerCompleteAllTaskEvent = false;
        let i;


        this.isExecuteUploadTasksRunning = true;


        if (this.Status == "Ready" || this.Status == "Running") {

            if (typeof (this.maxRunningTaskCount) != "undefined") {
                this.MaxRunningTaskCount = this.maxRunningTaskCount;
            }

            runningTaskCount = this.GetRunningTaskCount();

            for (i = 0; i < this.Tasks.length; i++) {
                if (runningTaskCount < this.MaxRunningTaskCount) {
                    if (this.Tasks[i].Status == "Ready") {
                        this.Tasks[i].Start();
                        runningTaskCount++;
                    }
                }
                else {
                    break;
                }
            }
        }

        if (runningTaskCount > 0) {


            this.isExecuteUploadTasksRunning = true;
            this.Status = "Running";

            setTimeout(
                function () {
                    this.ExecuteUploadTasksImpl();
                }.bind(this),
                1000
            );
        }
        else {
            this.Status = "Ready";
            this.isExecuteUploadTasksRunning = false;
        }//end if (runningTaskCount > 0) {




        if (runningTaskCount > 0) {
            this.isExecuteUploadTasksRunning = true;
            this.Status = "Running";

            setTimeout(
                function () {
                    this.ExecuteUploadTasksImpl();
                }.bind(this),
                1000
            );
        }
        else {

            if (this.Status == "Ready") {
                if ((new Date() - this.lastTriggerAllTaskCompleteTime) > 2000) {
                    triggerCompleteAllTaskEvent = true;
                }
            }
        }//end if (runningTaskCount > 0) {

        if (triggerCompleteAllTaskEvent) {

            this.lastTriggerAllTaskCompleteTime = new Date();

            if (this.AllTaskCompleted != null) {
                this.AllTaskCompleted();
            }
        }
    }//end ExecuteUploadTasksImpl() {


}//end let UploadManager = {




let uploadTaskIdSerialNo = 1;


function UploadTask(file, uploadPageUrl) {
    this.Id = 0;
    this.FileName = "";
    this.TempFileName = "";
    this.TargetFileName = "";
    this.Progress = 0;
    this.UploadPageUrl = uploadPageUrl;
    this.Status = "Ready"; //Ready , Running , Stop
    this.IsSend = false;
    this.AutoRename = false;
    this.Watermark = "";
    this.TargetFolderPath = "";
    this.KeepBaseName = false;



    /*
    ReadyState :
    0: request not initialized 
    1: server connection established
    2: request received 
    3: processing request 
    4: request finished and response is ready
    */
    this.ReadyState = 0;
    this.StartTime;
    this.EndTime;
    this.ElapsedTime = 0; //seconds
    this.FormData = new FormData();
    this.FileReader = new FileReader();
    this.XmlHttp = new XMLHttpRequest();
    this.File; //File 物件
    this.UploadPageParameter = "";
    this.StateChange = null;

    //Injection Event Start
    this.FileLoad = null; //預覽圖片用
    this.ProgressChange = null;
    this.Success = null;
    this.Fail = null;
    //Injection Event End

    this.Id = uploadTaskIdSerialNo++;
    this.File = file;
    this.FileName = file.name;

    this.FileReader.UploadTask = this;
}//end function UploadTask(file, uploadPageUrl) {




UploadTask.prototype.Start = function () {
    var url = "";
    var watermark = "";
    var watermarkPath = "";

    this.FormData.append('FileContent', this.File);

    this.XmlHttp.onerror = UplaodTaskError;
    this.XmlHttp.onreadystatechange = UplaodTaskStateChange;
    this.XmlHttp.upload.XmlHttp = this.XmlHttp;
    this.XmlHttp.upload.TaskId = this.Id;

    this.XmlHttp.upload.addEventListener(
        'progress',
        function (event) { UploadTaskProgressChange(event, this.TaskId) },
        false
    );

    url = this.UploadPageUrl;

    if (this.Watermark != "" && this.Watermark != null) {
        watermark = this.Watermark;
        if (watermark.indexOf("javascript:") < 0) {
            watermarkPath = watermark;
        }
        else {
            watermark = watermark.replace("javascript:", "");
            watermarkPath = eval(watermark);
        }
    }

    if (this.AutoRename == true) {
        if (url.indexOf("?") < 0) {
            url += "?";
        }
        else {
            url += "&";
        }

        url += "AutoRename=true";
    }

    if (watermarkPath != "") {
        if (url.indexOf("?") < 0) {
            url += "?";
        }
        else {
            url += "&";
        }

        url += "Watermark=" + watermarkPath;
    }

    if (this.TargetFolderPath != "") {
        if (url.indexOf("?") < 0) {
            url += "?";
        }
        else {
            url += "&";
        }

        url += "TargetFolderPath=" + this.TargetFolderPath;
    }

    if (this.KeepBaseName != null)
    {
        if (url.indexOf("?") < 0) {
            url += "?";
        }
        else {
            url += "&";
        }

        if (this.KeepBaseName == true) {
            url += "KeepBaseName=true";
        }
        else {
            url += "KeepBaseName=false";
        }
    }

    if (this.IsSend) {
        alert("XmlHttp is already Send !");
    }


    //this.XmlHttp.open('POST', url, true);
    this.XmlHttp.open('POST', url, true);


    //this.File.name = encodeURI(this.File.name);


    this.XmlHttp.setRequestHeader("X-File-Name", encodeURI(this.File.name));
    this.XmlHttp.setRequestHeader("X-File-Size", this.File.size);
    this.XmlHttp.setRequestHeader("X-File-Type", this.File.type);
    //this.XmlHttp.send(this.FormData);

    this.XmlHttp.send(this.File);

    this.IsSend = true;

    this.FileReader.onload = this.OnFileReaderLoad;
    this.FileReader.readAsDataURL(this.File);

    this.StartTime = new Date();
    this.Status = "Running";
}//end UploadTask.prototype.Start = function () {



UploadTask.prototype.Stop = function () {
    this.EndTime = new Date();

    this.XmlHttp.onreadystatechange = null;
    this.XmlHttp.upload.removeEventListener(
        'progress',
        this.OnProgressChange,
        false
    );

    this.XmlHttp.abort();

    this.Status = "Stop";
}//end UploadTask.prototype.Stop = function () {


UploadTask.prototype.Dispose = function () {
    this.XmlHttp = null;
    this.FormData = null;
}//end UploadTask.prototype.Dispose = function () {


UploadTask.prototype.OnReadyStateChange = function () {
    this.ReadyState = this.XmlHttp.readyState;

    if (this.ReadyState == 4) {
        this.EndTime = new Date();

        //if (this.XmlHttp.status == "200" || this.XmlHttp.status == "0") {
        if (
            (this.XmlHttp.status == "200" || this.XmlHttp.status == "0")
            &&
            (this.XmlHttp.responseText != "")
        ) {
            this.OnSuccess(this.XmlHttp.responseText);
        }
        else {
            this.OnFail(this.XmlHttp.responseText);
        }
    }
}//end UploadTask.prototype.OnReadyStateChange = function () {


UploadTask.prototype.OnProgressChange = function (e) {
    var newProgress = 0;

    newProgress = Math.ceil(e.loaded * 100 / e.total);

    if (newProgress != this.Progress) {
        this.Progress = newProgress;

        if (this.ProgressChange != null) {
            this.ProgressChange(this.Id, this.Progress);
        }
    }
}//end UploadTask.prototype.OnProgressChange = function (e) {


UploadTask.prototype.OnFileReaderLoad = function (e) {
    var uploadTask;

    uploadTask = this.UploadTask;
    uploadTask.TempFileName = e.target.result;

    if (uploadTask.FileLoad != null) {
        uploadTask.FileLoad(uploadTask.Id, e.target.result);
    }
}//end UploadTask.prototype.OnFileReaderLoad = function (e) {



UploadTask.prototype.OnSuccess = function (responseText) {
    if (this.Success != null) {
        this.Success(this.Id, responseText);
    }

    this.Status = "Stop";

    if (typeof (AfterUploadTaskSuccess) != "undefined") {
        AfterUploadTaskSuccess();
    }
}//end UploadTask.prototype.OnSuccess = function (responseText) {


UploadTask.prototype.OnFail = function (responseText) {
    if (this.Fail != null) {
        this.Fail(this.Id, responseText);
    }

    this.Status = "Stop";
}//end UploadTask.prototype.OnFail = function (responseText) {




function UplaodTaskStateChange(e) {
    var i;

    for (i = 0; i < UploadManager.Tasks.length; i++) {
        if (UploadManager.Tasks[i].XmlHttp == e.srcElement) {
            UploadManager.Tasks[i].OnReadyStateChange();
            break;
        }
    }
}


function UplaodTaskError(e) {
    var i;

    for (i = 0; i < UploadManager.Tasks.length; i++) {
        if (UploadManager.Tasks[i].XmlHttp == e.srcElement) {
            UploadManager.Tasks[i].OnFail();
            break;
        }
    }
}

function UploadTaskProgressChange(evt, taskId) {
    var i;


    for (i = 0; i < UploadManager.Tasks.length; i++) {
        if (UploadManager.Tasks[i].Id == taskId) {
            UploadManager.Tasks[i].OnProgressChange(evt);
            break;
        }
    }
}

export default UploadManager;
